import store from '../../../store'

// Pricing Engine v2 admin screens: Admin only today (config/pricing.php on the API side holds the same list).
export const PRICING_ADMIN_ROLES = ['Admin']

export const isPricingAdmin = () => {
	const u = store.state.authUser
	return !!u && PRICING_ADMIN_ROLES.includes(u.role)
}

export default (to, from, next) => {
	if (!store.getters['isAuth']) return next({ name: 'login' })
	if (isPricingAdmin()) return next()
	next({ path: '/pricing' })
}
